/**
 * N-400 weight (3-digit pounds). Keep in sync with Portal-Backend/services/usWeightLbsValidation.js
 */

const WEIGHT_MESSAGE =
  "Enter all three digits of your weight in pounds (use 0 in the first box if needed).";

function coerceWeightObject(
  raw: unknown,
): Record<string, unknown> | null {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    return raw as Record<string, unknown>;
  }
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const s = String(Math.trunc(raw)).padStart(3, "0").slice(-3);
    return { pounds_1: s[0], pounds_2: s[1], pounds_3: s[2] };
  }
  if (typeof raw === "string" && /^\d+$/.test(raw.trim())) {
    const s = raw.trim().padStart(3, "0").slice(-3);
    return { pounds_1: s[0], pounds_2: s[1], pounds_3: s[2] };
  }
  return null;
}

export type UsWeightLbsValidationResult =
  | {
      ok: true;
      normalized: { pounds_1: string; pounds_2: string; pounds_3: string };
    }
  | { ok: false; message: string };

export function validateUsWeightLbs(
  raw: unknown,
): UsWeightLbsValidationResult {
  const obj = coerceWeightObject(raw);
  if (!obj) {
    return { ok: false, message: WEIGHT_MESSAGE };
  }

  const d1 = String(obj.pounds_1 ?? "").trim();
  const d2 = String(obj.pounds_2 ?? "").trim();
  const d3 = String(obj.pounds_3 ?? "").trim();

  if (!/^\d$/.test(d1) || !/^\d$/.test(d2) || !/^\d$/.test(d3)) {
    return { ok: false, message: WEIGHT_MESSAGE };
  }

  return {
    ok: true,
    normalized: { pounds_1: d1, pounds_2: d2, pounds_3: d3 },
  };
}
